/**
 * @module events/types/message
 */

/**
 * @type {string}
 */
export default 'message'
